import {jsx as _jsx} from "react/jsx-runtime";import graphql from 'babel-plugin-relay/macro'
import {useEffect} from 'react'
import {useFragment} from 'react-relay'
import { withRouter} from 'react-router'

import useAtmosphere from '../hooks/useAtmosphere'
import useDocumentTitle from '../hooks/useDocumentTitle'
import useMetaTagContent from '../hooks/useMetaTagContent'
import useRouter from '../hooks/useRouter'
import {LocalStorageKey} from '../types/constEnums'
import InvitationLinkAuthentication from './InvitationLinkAuthentication'
import InvitationLinkErrorExpired from './InvitationLinkErrorExpired'
import TeamInvitationAccept from './TeamInvitationAccept'
import TeamInvitationErrorNotFound from './TeamInvitationErrorNotFound'





const InvitationLinkDialog = (props) => {
  const atmosphere = useAtmosphere()
  const {match} = useRouter()
  const {params} = match
  const {token} = params
  useEffect(() => {
    window.localStorage.setItem(LocalStorageKey.INVITATION_TOKEN, token)
  }, [token])
  const {massInvitation: massInvitationRef} = props
  const massInvitation = useFragment(
    graphql`
      fragment InvitationLinkDialog_massInvitation on MassInvitationPayload {
        ...InvitationLinkErrorExpired_massInvitation
        errorType
        inviterName
        teamName
      }
    `,
    massInvitationRef
  )
  if (!massInvitation) {
    // rate limit reached or other server error
    return _jsx(TeamInvitationErrorNotFound, { isMassInvite: true,} )
  }
  const {errorType, teamName} = massInvitation
  const pageTitle = teamName ? `${teamName} | Parabol` : 'Join | Parabol'
  const pageName = teamName ? `Join ${teamName}` : 'Join Parabol'
  const metaCopy = teamName
    ? `Join ${teamName} on Parabol, the essential tool for making meetings efficient or replacing them with structured, asynchronous collaboration.`
    : `Join Parabol, the essential tool for making meetings efficient or replacing them with structured, asynchronous collaboration.`
  /* eslint-disable react-hooks/rules-of-hooks */
  useDocumentTitle(pageTitle, pageName)
  useMetaTagContent(metaCopy)

  switch (errorType) {
    case 'notFound':
      return _jsx(TeamInvitationErrorNotFound, { isMassInvite: true,} )
    case 'expired':
      return _jsx(InvitationLinkErrorExpired, { massInvitation: massInvitation,} )
  }
  const {authToken} = atmosphere
  if (authToken) {
    return _jsx(TeamInvitationAccept, { invitationToken: token,} )
  }
  return _jsx(InvitationLinkAuthentication, { teamName: teamName, invitationToken: token,} )
}

export default withRouter(InvitationLinkDialog)
